import http from '../http'

/**
 * 获取新闻\展会列表
 * @param params
 * @return {*}
 */
export function getNewsListSrv(params) {
  let url = '/information/queryValidInformationList'
  return http.post(url,params)
}

/**
 *入驻品牌列表
 *@param params
 *@return {*}
 */
export function brandListSrv(params) {
  let url = '/product/queryBrandList'
  return http.post(url,params)
}

/**
 * 设备列表
 * @param params
 * @return {*}
 */
export function machineListSrv(params) {
  let url = "/product/queryMachineList"
  return http.post(url,params)
}
/**
 * 轮播图(广告)
 * @param params
 * @return {*}
 */
export function carouselSrv(params) {
  let url = '/information/queryValidAdvertisingList'
  return http.post(url, params)
}
/**
 * 退出登录
 * @param params
 * @return {*}
 */
export function logOutSrv(params) {
  let url = '/logout'
  return http.post(url, params)
}



// WEBPACK FOOTER //
// ./src/api/home/home.js